import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_PRODUCT_CATEGORY = gql`
  mutation CreateMasterDataProductCategory(
    $params: CreateMasterDataProductCategoryInput!
  ) {
    createMasterDataProductCategory(params: $params) {
      productCategoryId
      categoryKey
      name
      description
      isActive
      searchVectorKeywords
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const UPDATE_MASTER_DATA_PRODUCT_CATEGORY = gql`
  mutation UpdateMasterDataProductCategory(
    $params: UpdateMasterDataProductCategoryInput!
  ) {
    updateMasterDataProductCategory(params: $params) {
      productCategoryId
      categoryKey
      name
      description
      isActive
      searchVectorKeywords
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
